import React from 'react';
import { PageContentLayout } from '@/finsight/ui/common/components/ContentLayouts';
import LoanLevel from '@/finsight/ui/components/filings/LoanLevel';
import withFinsightGlobalProps from '@/finsight/application/withFinsightGlobalProps';
import IBreadcrumb from '@/finsight/domain/vo/Breadcrumbs';
import { FilingsResponse } from '@/finsight/domain/vo/Filings/Filings';
import getServerSideLoanLevelBreadcrumbs
  from '@/finsight/application/Breadcrumbs/serverSide/getServerSideLoanLevelBreadcrumbs';
import FilingsContextProvider from '@/finsight/application/Filings/FilingsContext';
import getServerSideFilings
  from '@/finsight/application/Filings/serverSide/getServerSideFilings';

export const getServerSideProps = withFinsightGlobalProps(async (context) => {
  const [breadcrumbs, filingsData] : [IBreadcrumb[], FilingsResponse] = await Promise.all([
    getServerSideLoanLevelBreadcrumbs(),
    getServerSideFilings(context),
  ]);

  return ({
    props: {
      breadcrumbs,
      filingsData,
    },
  });
});

const AssetBackedSecurities = (props) => (
  <PageContentLayout>
    <FilingsContextProvider filingsData={ props.filingsData }>
      <LoanLevel />
    </FilingsContextProvider>
  </PageContentLayout>
);

export default AssetBackedSecurities;
